const mediaItems = [
  {
    id: 1,
    title: '午夜专场 · 最新上线',
    source: '蜜桃视频',
    duration: '1:28:36',
    views: '36.8万',
    tag: '限时',
  },
  {
    id: 2,
    title: '动作大片 · 硬汉必看',
    source: '香蕉视频',
    duration: '2:05:12',
    views: '52.3万',
    tag: '热门',
  },
  {
    id: 3,
    title: '综艺爆笑 · 最新一期',
    source: '樱花视频',
    duration: '1:15:48',
    views: '28.9万',
    tag: '新番',
  },
  {
    id: 4,
    title: '推理剧场 · 高能烧脑',
    source: '红桃视频',
    duration: '1:42:20',
    views: '41.6万',
    tag: '精品',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">精选视频</h2>
        <p className="section-subtitle">每日精选优质内容，快速找到你想看的</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mt-10">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden group cursor-pointer hover:border-primary-300 transition-colors"
            >
              <div className="relative aspect-video bg-gradient-to-br from-foreground-700 via-foreground-800 to-foreground-900 flex items-center justify-center">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center backdrop-blur-sm group-hover:bg-white/25 transition-colors">
                    <i className="ri-play-fill text-white text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 bg-primary-500 text-white text-[10px] font-medium rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="px-1.5 py-0.5 bg-black/50 text-white text-[10px] rounded whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-vidicon-line"></i>
                    {item.source}
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}